import BankCardForm from './BankCardForm'

export default BankCardForm
